import { CardEligibility } from './card-eligibility.js';
let CardPacksData = {};

CardPacksData = (function () {
  function isNonCraftableCard(card) {
    if (!card) return false;
    if (CardEligibility?.isNonCraftableCard) {
      return CardEligibility.isNonCraftableCard(card);
    }
    const type = String(card.type || '').toLowerCase();
    if (type === 'spell') return false;
    if (card.isForged === true) return false;
    if (String(card.collection || '') === 'Moon Foundry') return false;
    return true;
  }

  function filterEligiblePackCards(cards = []) {
    return (cards || []).filter((card) => isNonCraftableCard(card));
  }

  function buildPackCardView({ packItems = [], allCards = [] } = {}) {
    const cardById = new Map((allCards || []).map((card) => [card.id, card]));

    return (packItems || []).map((item, index) => {
      const card = cardById.get(item.cardId) || null;
      const baseName = card?.name || item.cardId || 'Unknown Card';
      return {
        index,
        cardId: item.cardId,
        isStellar: item.isStellar === true,
        claimed: item.claimed === true,
        cardName: item.isStellar ? `${baseName} (Stellar)` : baseName,
        cardImage: card?.image || '',
        card,
      };
    });
  }

  function calculatePackSpread({ stageWidth, cardWidth, count, buffer, hoverScale } = {}) {
    const safeStage = Number(stageWidth);
    const safeCard = Number(cardWidth);
    const safeCount = Math.max(1, Math.floor(Number(count || 0)));
    if (!Number.isFinite(safeStage) || !Number.isFinite(safeCard)) return 0;
    if (safeStage <= 0 || safeCard <= 0) return 0;

    const maxOffset = Math.max(1, Math.floor((safeCount - 1) / 2));
    const padding = Number.isFinite(buffer) ? buffer : Math.max(16, safeCard * 0.2);
    const scale = Number.isFinite(hoverScale) ? Math.max(1, hoverScale) : 1;
    const scaledWidth = safeCard * scale;
    const maxCenterOffset = safeStage / 2 - scaledWidth / 2 - padding;
    const maxSpread = maxCenterOffset / maxOffset;
    // Near edge-to-edge fanning: with an in-place enlarged hover, a tighter
    // fan makes neighbouring cards unreachable under the pointer.
    const defaultSpread = safeCard * 0.95;

    if (!Number.isFinite(maxSpread)) return 0;
    return Math.max(0, Math.min(defaultSpread, maxSpread));
  }

  function calculateNonCraftableDuplicateValue({
    allCards = [],
    ownedCardMap,
    ownedCardStellarMap,
    normalDuplicateValue = 1,
    stellarDuplicateValue = 20,
  } = {}) {
    if (!ownedCardMap || typeof ownedCardMap.get !== 'function') return 0;
    const stellarMap = ownedCardStellarMap instanceof Map ? ownedCardStellarMap : new Map();
    const cardById = new Map((allCards || []).map((card) => [card.id, card]));
    const normalValue = Math.max(1, Math.floor(Number(normalDuplicateValue) || 1));
    const stellarValue = Math.max(1, Math.floor(Number(stellarDuplicateValue) || 20));
    let total = 0;

    ownedCardMap.forEach((qty, cardId) => {
      const count = Math.floor(Number(qty || 0));
      if (!Number.isFinite(count) || count <= 1) return;
      const card = cardById.get(cardId);
      if (!isNonCraftableCard(card)) return;
      total += (count - 1) * normalValue;
    });

    stellarMap.forEach((qty, cardId) => {
      const count = Math.floor(Number(qty || 0));
      if (!Number.isFinite(count) || count <= 1) return;
      const card = cardById.get(cardId);
      if (!isNonCraftableCard(card)) return;
      total += (count - 1) * stellarValue;
    });

    return total;
  }

  return {
    filterEligiblePackCards,
    buildPackCardView,
    calculatePackSpread,
    calculateNonCraftableDuplicateValue,
  };
})();

export { CardPacksData };
